import React from "react";
import PropTypes from "prop-types";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Modal } from "@domestika-dev/prudencio/dist/molecules/Modal";
import { Text, TextForm } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Grid } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { FormattedMessage } from "react-intl";

const DeleteModal = ({ setOpen, confirmAction, isOpen }) => (
  <Modal
    width="auto"
    heigth="auto"
    isOpen={isOpen}
    id="dmstk-delete-modal"
    onModalClose={() => setOpen(false)}
  >
    <Modal.Title>
      <FormattedMessage id="projects.new.delete_confirmation.title" />
    </Modal.Title>

    <Modal.Content>
      <Text size="small" textAlign="center">
        <FormattedMessage id="projects.new.delete_confirmation.body" />
      </Text>
    </Modal.Content>

    <Modal.Actions>
      <Grid gridTemplateColumns="1fr 1fr" gridTemplateRows="1fr" gridColumnGap={3} marginTop={5}>
        <Button size="medium" hollow="secondary" buttonType="secondary" id="cancel-button">
          <TextForm size={["tiny", "tiny", "small"]} fontWeight="medium" color="sonar">
            <FormattedMessage id="projects.new.delete_confirmation.button.cancel" />
          </TextForm>
        </Button>

        {/* // TODO: Add confirm delete action */}
        <Button size="medium" action={confirmAction && confirmAction}>
          <TextForm size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
            <FormattedMessage id="projects.new.delete_confirmation.button.delete" />
          </TextForm>
        </Button>
      </Grid>
    </Modal.Actions>
  </Modal>
);

DeleteModal.propTypes = {
  setOpen: PropTypes.func,
  confirmAction: PropTypes.func,
  isOpen: PropTypes.bool,
};

DeleteModal.defaultProps = {
  setOpen: () => {},
  confirmAction: () => {},
  isOpen: false,
};

export default DeleteModal;
